import Swiper from 'swiper';
import { EffectFade, Autoplay, A11y } from 'swiper/modules';

export default class LocationPage {
  constructor() {
    this.conceptSlider();
    this.conceptScrollProgress();
  }

  // コンセプト背景の環境写真スライド（フェード）
  conceptSlider() {
    const el = document.querySelector('.js-conceptSlider');
    if (!el) return;

    new Swiper(el, {
      modules: [EffectFade, Autoplay, A11y],
      effect: 'fade',
      fadeEffect: { crossFade: true },
      loop: true,
      speed: 1500,
      allowTouchMove: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false
      },
      a11y: {
        enabled: true,
        prevSlideMessage: '前のスライドへ',
        nextSlideMessage: '次のスライドへ'
      }
    });
  }

  // container がせり上がる進捗を --mv-progress にセット（conceptArea のテキスト表示に使用）
  conceptScrollProgress() {
    const container = document.querySelector('.main > .container');
    if (!container) return;

    const root = document.documentElement;
    let ticking = false;
    let lastProgress = -1;

    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      if (vh <= 0) return;
      const rect = container.getBoundingClientRect();
      const progress = Math.max(0, Math.min(1, 1 - rect.top / vh));
      if (Math.abs(progress - lastProgress) >= 0.001) {
        root.style.setProperty('--mv-progress', progress.toFixed(3));
        lastProgress = progress;
      }
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('lenis-scroll', onScroll);
    window.addEventListener('resize', onScroll);
  }
}
